import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

import StudentDiffForm from "./StudentDiffForm";

import "../../../styles/RatingTable.scss";
import "../../../styles/SingleStudentRatings.scss";

const StudentDiffModal = (props) => {
    const { show, setShow, student, selectedTemplate } = props;

    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            size="xl"
            backdrop="static"
            scrollable
            dialogClassName="diff-modal"
            contentClassName="diff-modal-content"
            aria-labelledby="epr-differentiation-modal-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="epr-differentiation-modal-title">
                    Differentiate {selectedTemplate?.subjectName} for {student?.firstName} {student?.lastName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <StudentDiffForm {...props} />
            </Modal.Body>
        </Modal>
    );
};

StudentDiffModal.propTypes = {
    onApplyExclusions: PropTypes.func,
    selectedTemplate: PropTypes.object,
    setShow: PropTypes.func,
    show: PropTypes.bool,
    student: PropTypes.object,
    studentProfileData: PropTypes.object
};
StudentDiffModal.defaultProps = {
    onApplyExclusions: () => {},
    selectedTemplate: null,
    setShow: () => {},
    show: false,
    student: null,
    studentProfileData: null
};

export default StudentDiffModal;
